import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { InternalFacilitiesMainComponent } from './containers/internal-facilities-main/internal-facilities-main.component';
import { EmailSignatureComponent } from './components/email-signature/email-signature.component';
import { AiAssistantComponent } from './components/ai-assistant-main/ai-assistant-main.component';
import { FeatureFlagsComponent } from './components/feature-flags/feature-flags.component';
import { featureFlagsResolver } from 'src/app/domains/feature-flags/resolvers/feature-flags.resolver';

const routes: Routes = [
  {
  path: '',
  component: InternalFacilitiesMainComponent,
  children: [
    { path: 'email-signature', component: EmailSignatureComponent },
    { path: 'ai-assistant', component: AiAssistantComponent },
    { 
      path: 'feature-flags', 
      component: FeatureFlagsComponent,
      resolve: { flagsLoaded: featureFlagsResolver },
    }
  ]
}
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class InternalFacilitiesRoutingModule {}
